export default "/images/volume.svg?a715247a114af7d4e171d3bc9ecb369e";